import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App.js';
import "@amzn/meridian-tokens/base/font/amazon-ember.css";
import { createStore, applyMiddleware } from "redux";
import {HashRouter} from 'react-router-dom';
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import rootReducer from "./reducers/rootReducer";
import './index.css';
import {IntlProvider, addLocaleData} from "react-intl";
import {getDirection, getLocale, getMessages} from "./handler/LocaleHandler";
import en from 'react-intl/locale-data/en'
import ja from 'react-intl/locale-data/ja'
import it from 'react-intl/locale-data/it'
import fr from 'react-intl/locale-data/fr'
import es from 'react-intl/locale-data/es'
import de from 'react-intl/locale-data/de'
import ar from 'react-intl/locale-data/ar'
import tr from 'react-intl/locale-data/tr'
import ErrorBoundary from "./components/utils/ErrorBoundary";

addLocaleData(en)
addLocaleData(ja)
addLocaleData(it)
addLocaleData(de)
addLocaleData(fr)
addLocaleData(es)
addLocaleData(ar)
addLocaleData(tr)

const store = createStore(
    rootReducer,
    //Thunk is a middleware that looks at every action that passes through the system, and if itâ€™s a function,
    // it calls that function. Thatâ€™s all it does.
    applyMiddleware(thunk)
);

//Routes
getLocale().then(locale => {
    document.getElementsByTagName(`html`)[0].setAttribute("dir", getDirection(locale));
    ReactDOM.render((
        <IntlProvider locale={locale} messages={getMessages(locale)}>
            <Provider store={store}>
                <HashRouter>
                    <ErrorBoundary>
                        <App/>
                    </ErrorBoundary>
                </HashRouter>
            </Provider>
        </IntlProvider>
    ), document.getElementById('root'))
})



// WEBPACK FOOTER //
// ./src/index.js